import { Routes } from '@angular/router';
import { AuthResolver } from './resolvers/auth-resolver';

export const TradeFinanceRootRoutes: Routes = [
    {
        path: '',
        resolve: { auth: AuthResolver },
        loadChildren: () => {
            return import('./app.module').then((r) => r.AppModule);
        }
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];